export default __webpack_public_path__ + "../assets-configurator/272b22470aebb193aaf17f0368621432.svg";